import React, { Component } from 'react';

import {} from './Home.css';

class MainHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 Home";
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="container">
                <br/>
                    <h1 className="title">g-C3N4 - Graphitic Carbon Nitride</h1>
                    <p className="subtitle">Welcome to the World of Graphitic Carbon Nitride</p>
                    <p>Graphitic carbon nitride (g-C3N4) is a family of compounds with a general formula near to C3N4 and structures based on heptazine units which, depending on reaction conditions, exhibit different degrees of condensation, properties and reactivities. </p>
                    <div className="Home-content-left">
                    <p>g-C3N4 is being investigated for use in a wide variety of fields:</p>
                    <ul>
                        <li>Hydrogen Generation</li>
                        <li>Photovoltaics</li>
                        <li>Carbon Dioxide Reduction</li>
                        <li>Semiconductors</li>
                        <li>Cryogentics</li>
                    </ul>
                    </div>
                    <div className="Home-content-right">
                        <p>There are many other fields of research in which graphitic carbon nitride plays a crutial role.</p> 
                         <p>The more its remarkable behaviour is understood, the more facinating it becomes and the more potential applications are discovered.  </p>
                    </div>
                    <img className="Home-allotropes" src="/allotropes.png" alt="The structure of g-C3N4" />
                    <p className="Home-allotropes-caption">Triazine- (left) and tri-s-triazine-based connection patterns (right) of potential g-C3N4 allotropes.</p>
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default MainHome;


// WEBPACK FOOTER //
// ./src/Home/Home.js